import React, { Component } from 'react';
import {Tabs, Button, WhiteSpace, WingBlank, Toast, Modal, Flex} from 'antd-mobile'
import PigLet from './piglet'
import Pig from './pig'
import Sow from './sow'
import Boar from './boar'
import send_init from '../../../utils/send_init';
import auth from '../../../utils/auth';
import {ROOT_PATH} from '../../../config';
import web from '../../../utils/native'
const ModalAlert = Modal.alert;
export default class Swine extends Component {
  constructor (props) {
    super(props);
    this.state = {
      mateGroupSource: [], // 种公母猪的配种组数据
      tab: 0,
      tabs: [
        {
          title: '公猪'
        },
        {
          title: '母猪'
        },
        {
          title: '仔猪'
        },
        {
          title: '肥猪'
        }
      ]
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  async componentDidMount() {
    // 1.请求默认数据。
    // 公猪母猪默认值
    // 配种组
    this.getMateGroup(); // 把配种组先获取了
  }
  getMateGroup = () => {
    send_init({
      url: `${ROOT_PATH}/api/ifarm/v1/genealogy/mate_group?project=SW`,
      method: 'GET'
    })
      .then(res => {
        this.setState({
          mateGroupSource: res.data
        })
      })
  };
  doSave = () => {
    const swineReq = auth.readCookie('swineReq') || [];
    const pigReq = auth.readCookie('pigReq') || [];
    const female = swineReq.filter(o=>o.sex==='F');
    const male = swineReq.filter(o=>o.sex==='M');
    const piglet = pigReq.filter(o=>o.stockType === '52');
    const pig = pigReq.filter(o=>o.stockType === '51');
    const pigSum = pig.reduce((sum,o) => o.femaleQty * 1 + o.maleQty * 1 + sum ,0);
    const pigletSum = piglet.reduce((sum,o) => (o.femaleQty * 1 + o.maleQty * 1 + sum) ,0);
    ModalAlert('请确认您要添加的猪只数量', <div>
      <Flex justify={'around'}>
        <span>公猪: <b>{male.length}</b>头</span>
        <span>母猪: <b>{female.length}</b>头</span>
      </Flex>
      <Flex justify={'around'}>
        <span>肥猪: <b>{pigSum}</b>头</span>
        <span>仔猪: <b>{pigletSum}</b>头</span>
      </Flex>
    </div>, [
      { text: '留在此页',
        onPress: () => {},
        style: 'default'
      },
      {
        text: '提交数据',
        onPress: () => {
          this.saveData()
        }
      }
    ]);
  };
  getSaveData = () => {
    //  完成所有简版添加步骤
    //  1. 校验数据。如果 猪只管理新增有数据，则允许保存
    const swineReq = auth.readCookie('swineReq') || [];
    const pigReq = auth.readCookie('pigReq') || [];
    const product = auth.readCookie('product' || {});
    const feed = product.feed.map(o => {
      const  cal = o.calculateMethod;
      const  num = o.num || 0;
      let wgh = 0;
      let qty = 0;
      if (cal === 'W') {
        wgh = Number(num);
        qty = 0
      }
      if (cal === 'Q') {
        wgh = Number(num) * (o.salePackingSize || 0);
        qty = Number(num)
      }
      return {
        ...o,
        wgh,
        qty
      }
    });
    const medicine = product.medicine.map(o => {
      const  cal = o.calculateMethod;
      const  num = o.num || 0;
      let wgh = 0;
      let qty = 0;
      if (cal === 'W') {
        wgh = Number(num);
        qty = 0
      }
      if (cal === 'Q') {
        wgh = Number(num) * (o.salePackingSize || 0);
        qty = Number(num)
      }
      return {
        ...o,
        wgh,
        qty
      }
    });
    const semen = product.semen.map(o => {
      const  cal = o.calculateMethod;
      const  num = o.num || 0;
      let wgh = 0;
      let qty = 0;
      if (cal === 'W') {
        wgh = Number(num);
        qty = 0
      }
      if (cal === 'Q') {
        wgh = Number(num) * (o.salePackingSize || 0);
        qty = Number(num)
      }
      return {
        ...o,
        wgh,
        qty
      }
    });
    const vaccine = product.vaccine.map(o => {
      const  cal = o.calculateMethod;
      const  num = o.num || 0;
      let wgh = 0;
      let qty = 0;
      if (cal === 'W') {
        wgh = Number(num);
        qty = 0
      }
      if (cal === 'Q') {
        wgh = Number(num) * (o.salePackingSize || 0);
        qty = Number(num)
      }
      return {
        ...o,
        wgh,
        qty
      }
    });
    const  farm = auth.readCookie('farm');
    return {
      farm,
      vaccine,
      semen,
      medicine,
      swineReq,
      pigReq,
      feed
    }
  };
  saveData = async () => {
    const {
      farm,
      vaccine,
      semen,
      medicine,
      swineReq,
      pigReq,
      feed
    } = this.getSaveData();
    if (swineReq.length === 0 && pigReq.length === 0) {
      // 没有添加猪只
      Toast.fail('请添加猪只信息后再保存', 2);
      return;
    }
    //   说明已经存了猪只信息
    //  发请求
    this.setState({saving: true});
    Toast.loading('保存中,请不要退出！',5);
    let step3 = await send_init({
      url: '/api/forward/ifarm/simpleStep/saveStep3',
      method: 'post',
      data: {
        materialReq: {
          feed,
          medicine,
          vaccine,
          semen
        },
        swineReq,
        pigReq
      }
    });
    if (step3.data.statusCode !== '200') {
      Toast.info(step3.data.msg,2);
      return;
    }
    const farmName = auth.readCookie('farm').farmName + '管理农场';
    const farm_code = auth.readCookie('FARMORG') + '-0-0';
    const org_code = auth.readCookie('ORGCODE');
    const createdStaffs = auth.readCookie('createdStaffs').staffs;
    const staffs = createdStaffs.map(o => {
      return {
        username: o.username,
        phoneNum: o.phoneNum,
        id: o.id,
        contact: o.contact
      }
    } );
    const provinceName = JSON.parse(farm.address[0]).name;
    Toast.loading('保存中,请不要退出！',5);
    let step4 = await send_init({
      url: '/api/ifarm/v180/staff/batch',
      method: 'post',
      data: {
        farm_code,
        farm_name: farmName,
        company_code: org_code.substr(0,4),
        company_name: provinceName + '养殖公司', // 省份名称 + '养殖公司'
        org_code,
        org_name: farmName,
        staffs
      }
    });
    if (step4.data.statusCode !== 200) {
      Toast.info(step4.data.message, 2);
      return;
    }
    Toast.success('创建农场成功',2, () =>{
      // 回到主页
      // 清楚数据
      auth.deleteCookie();
      web.callNativeModal('backHome');
    })
  };
  render() {
    const {tabs, tab,mateGroupSource} = this.state;
  return (
    <div>
      <Tabs tabs={tabs}
          animated={false}
          initialPage={tab}
          swipeable={false}
          onTabClick={(tab, index) => {
              this.setState({tab: index})
            }}
      >
        <div>
          <Boar mateGroupSource={mateGroupSource} />
        </div>
        <div>
          <Sow mateGroupSource={mateGroupSource} />
        </div>
        <div>
          <PigLet />
        </div>

        <div>
          <Pig  />
        </div>
      </Tabs>
      <WingBlank size={'lg'}>
        <WhiteSpace size={'sm'} />
        <Button type={'primary'}
            disabled={this.state.saving}
            onClick={this.doSave}
        >创建完成</Button>
{/*
        <Button onClick={()=>{
          auth.deleteCookie()
        }}>clear</Button>*/}
      </WingBlank>

    </div>
  )
 }
}
